import { COMMUNITY_SLUGS } from '@highlight-cp/constants';

export const STEP = {
  PHONE: 'phone',
  NAME: 'name',
  DOB: 'dob',
  ADDRESS: 'address',
  EMAIL: 'email',
} as const;

export const STEPS = Object.values(STEP);

/** Communities where activation is handled manually by staff, not automatically on profile completion. */
export const MANUAL_ACTIVATION_COMMUNITY_SLUGS: readonly string[] = [
  COMMUNITY_SLUGS.GOOD_HOUSEKEEPING_MEMBERSHIP,
  COMMUNITY_SLUGS.ACME_GRAVITAS,
] as const;
